import {atom} from "recoil";

const state = atom({
    key: 'loginPage',
    default: {}
});

export default state
